import i18next from "i18next";
import type {
  CustomDomainSsoErrorResponse,
  ErrorResponse,
  RegistrationsErrorResponse,
  SsoValidationErrorResponse,
} from "src/types";

export function isError(obj: unknown): obj is ErrorResponse {
  return Boolean(
    (obj as ErrorResponse)?.code &&
      (obj as ErrorResponse)?.title &&
      (obj as ErrorResponse)?.description
  );
}

export function isCustomDomainSsoError(
  obj: unknown
): obj is CustomDomainSsoErrorResponse {
  return Boolean((obj as CustomDomainSsoErrorResponse)?.error);
}

export function isSsoValidationError(
  obj: unknown
): obj is SsoValidationErrorResponse {
  return Boolean((obj as SsoValidationErrorResponse)?.error);
}

export function isRegistrationError(
  obj: unknown
): obj is RegistrationsErrorResponse {
  return Boolean(
    (obj as RegistrationsErrorResponse)?.code &&
      (obj as RegistrationsErrorResponse)?.error
  );
}

export function parseErrorMessage(errorResponse: ErrorResponse) {
  const errorMessage = errorResponse.description.toLowerCase();
  return 400 <= errorResponse.code && errorResponse.code < 500
    ? i18next.t("common.error-response.bad-request", { errorMessage })
    : i18next.t("common.error-response.general");
}
